import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrl: './page-loader.component.scss',
  standalone: false
})
export class PageLoaderComponent {

  @Input() isLoading = false;

  @Input() title = 'Working on it';

  @Input() message = 'Please wait while we process your request.';

}
